export const FIRST_TOUCH_COOKIE_NAME = "poc_first_touch"
export const FIRST_TOUCH_MAX_AGE_SECONDS = 60 * 60 * 24 * 14

const readCookie = (name: string): string | undefined => {
    if (typeof document === "undefined") return undefined

    const prefix = `${name}=`
    const row = document.cookie.split("; ").find(cookie => cookie.startsWith(prefix))
    if (!row) return undefined

    const raw = row.slice(prefix.length)
    if (!raw) return undefined

    try {
        return decodeURIComponent(raw)
    } catch {
        return raw
    }
}

const writeCookie = (name: string, value: string, maxAge: number): void => {
    if (typeof document === "undefined") return

    const secure =
        typeof location !== "undefined" && location.protocol === "https:"
            ? "; Secure"
            : ""

    document.cookie = `${name}=${value}; path=/; max-age=${maxAge}; samesite=lax${secure}`
}

export const readFirstTouch = (): string | undefined =>
    readCookie(FIRST_TOUCH_COOKIE_NAME)

export const writeFirstTouchIfEmpty = (href: string): void => {
    if (readFirstTouch()) return

    try {
        new URL(href)
    } catch {
        return
    }

    writeCookie(
        FIRST_TOUCH_COOKIE_NAME,
        encodeURIComponent(href),
        FIRST_TOUCH_MAX_AGE_SECONDS
    )
}

export const clearFirstTouch = (): void => {
    writeCookie(FIRST_TOUCH_COOKIE_NAME, "", 0)
}
